// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.titleClass[data-v-54b76edf] {\n  font-size: 18px;\n  font-weight: bold;\n  margin-bottom: 10px;\n}\n.printStyle[data-v-54b76edf] {\n  display: none;\n}\n.app-container[data-v-54b76edf] .el-alert {\n  background-color: #F2FBF6;\n  color: #00A551;\n}\n.tip01[data-v-54b76edf] {\n  background-color: #F2FBF6;\n  color: #00A551;\n  padding: 5px 10px;\n  font-size: 14px;\n  border-radius: 5px;\n  margin-bottom: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
